import styled from "styled-components";
import { Box } from "theme-ui";
import { themevals } from "theme/themevals";

interface CustomProps {
  $submitting?: boolean;
  $errors?: any;
}

export const InputWrap = styled(Box)<CustomProps>`
  && {margin-bottom: 30px;}

  display: flex;
  flex-direction: column;
  position:relative;  
`;

export const labelStyles = {
  marginBottom: 0,
  display: "flex",
  justifyContent : "space-between",
  alignItems: "flex-end",
  fontSize: 14,
  fontWeight: 500
};

export const LabelWrapper =  styled.div`
  margin-bottom: 10px;
  display: flex;
  width: 100%;
  label {
    color: ${themevals.colors.body};
    ${labelStyles}
  }
  small {
    font-style: italic; font-size: .75rem; color: ${themevals.colors.ltgrey};
  }
`;

export const DropArea = styled.div` 
  border: 1px solid #ebebeb;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  user-select: none;
  border-radius: 6px;
  font-family:Poppins;
`;

export const DropAreaLabel = styled.div`
  font-weight: 500;
  color:${themevals.colors.base_500};
  font-family:Poppins;
  font-size:14px;
`;

export const Error = styled.div` 
  color:${themevals.colors.danger};
  margin-top:2px; 
  font-size:14px;
`